import styled from 'styled-components';
import Colors from '../../const/Colors';
import { map } from '../../const/theme';

export const ByeWrapper = styled.div`
  background: ${Colors.midnightBlue};
`;

export const ByeContainer = styled.div`
  max-width: 144rem;
  margin: 0 auto;
  color: ${Colors.white};
  min-height: 100vh;
  ${map({ tablet: 'flex' }, (display) => `display: ${display};`)};
  ${map(
    { tablet: 'column' },
    (flexDirection) => `flex-direction: ${flexDirection};`
  )};
  ${map(
    { tablet: 'flex-start' },
    (alignItems) => `align-items: ${alignItems};`
  )};
  ${map(
    { tablet: 'space-between' },
    (justifyContent) => `justify-content: ${justifyContent};`
  )};
`;

export const PaddedWrapper = styled.div`
  padding: 0 1.6rem;
  ${map({ tablet: '0 3.2rem' }, (padding) => `padding: ${padding};`)}
`;

export const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  ${map(
    { tablet: 'row' },
    (flexDirection) => `flex-direction: ${flexDirection};`
  )};
  ${map(
    { tablet: 'space-between' },
    (justifyContent) => `justify-content: ${justifyContent};`
  )};
  margin-top: 5.2rem;
`;

export const SorryText = styled.div`
  font-size: 8.8rem;
  ${map({ tablet: '17.2rem' }, (fontSize) => `font-size: ${fontSize};`)}
  line-height: 7.9rem;
  ${map({ tablet: '14.6rem' }, (lineHeight) => `line-height: ${lineHeight};`)}
  ${map({ tablet: '95rem' }, (maxWidth) => `max-width: ${maxWidth};`)}
  font-weight: bold;
  text-transform: uppercase;
  font-family: 'Kobe';
`;

export const EyeStyles = styled.div`
  width: 12.8rem;
  ${map({ tablet: '23rem' }, (width) => `width: ${width};`)};
  ${map({ tablet: '23rem' }, (minWidth) => `min-width: ${minWidth};`)};
  height: 10.2rem;
  ${map({ tablet: '18.3rem' }, (height) => `height: ${height};`)};
  ${map({ tablet: '18.3rem' }, (minHeight) => `min-height: ${minHeight};`)};
  align-self: flex-end;
  ${map({ tablet: 'flex-start' }, (alignSelf) => `align-self: ${alignSelf};`)};
  margin-top: 2.4rem;
  ${map({ tablet: '0rem' }, (marginTop) => `margin-top: ${marginTop};`)};
  margin-bottom: 2.8rem;
  ${map(
    { tablet: '0rem' },
    (marginBottom) => `margin-bottom: ${marginBottom};`
  )};
`;

export const Divider = styled.div`
  height: 0.1rem;
  background-color: ${Colors.bone};
  margin-bottom: 3rem;
  ${map(
    { tablet: '4rem' },
    (marginBottom) => `margin-bottom: ${marginBottom};`
  )};
  ${map({ tablet: '4rem' }, (marginTop) => `margin-top: ${marginTop};`)};
`;

export const Message = styled.div`
  font-size: 2.4rem;
  line-height: 3.4rem;
  margin-bottom: 3rem;
`;

export const ButtonWrapper = styled.div`
  padding-bottom: 3.8rem;
  ${map({ tablet: '22.6rem' }, (maxWidth) => `max-width: ${maxWidth};`)};
`;
